export const passengerTypeMap = {
  'ADT': 'ADULT',
  'CHD': 'CHILD',
  'INF': 'INFANT',
  'MWD': 'MWD',
  'PWD': 'PWD'
}
